<div
class="input-container switch"
[class.no-margin]="noMargin"
[class.error]="(ngControl.control.touched || ngControl.control.dirty) && ngControl.control.invalid">
    <label [class.on]="value" (click)="preventDefault ? handleClick($event) : null">
        <input type="checkbox" (change)="handleChange($event)" [(ngModel)]="value" [checked]="value">
        <span></span>
    </label>
</div>
